import { FoodsIllustrations, WhiteBox } from "@foodpilot/foods";
import { Stack, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type EmptyCardProps = {
    direction?: "row" | "column";
};

export const EmptyCard = (props: EmptyCardProps) => {
    const { direction = "row" } = props;
    const { t } = useTranslation();

    return (
        <EmptyComparisonCard direction={direction} key={`empty-card-${direction}`}>
            <FoodsIllustrations illustration="notEnoughData" />
            <Stack gap={1}>
                <Typography variant="h4">{t("score.details.comparison.noData.title")}</Typography>
                <Typography variant="body">{t("score.details.comparison.noData.description")}</Typography>
            </Stack>
        </EmptyComparisonCard>
    );
};

const EmptyComparisonCard = styled(WhiteBox)<{ direction: "row" | "column" }>(({ theme, direction = "column" }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: theme.spacing(4),
    flexDirection: direction,
    padding: theme.spacing(4),
    textAlign: direction === "row" ? "left" : "center",
}));
